<template>
	<TableRowSkeleton
		:columns="columns"
		:size="size"
	/>
</template>

<script>
import { TableRowSkeleton } from '@/components/Essentials/Skeleton'
export default {
	name: 'RowSkeleton',
	components: { TableRowSkeleton },
	props: {
		columns: { type: Array, default: () => [] },
		size: { type: String, default: 'default' }
	}
}
</script>
